/**
 * Order Form Validation Logic
 */
import { PositionInfo } from '../../types/portfolio';
import { formatCurrency } from '../../utils/formatNumber';
import { MIN_ORDER_AMOUNT } from './types';

export const getValidationError = (
  symbol: string,
  quantity: string,
  side: 'buy' | 'sell',
  selectedPosition: PositionInfo | null,
  estimatedAmount: number,
  accountCash: number
): string | null => {
  if (!symbol.trim()) return null;

  const qty = parseFloat(quantity);
  if (isNaN(qty) || qty <= 0) {
    return '유효한 수량을 입력하세요';
  }

  if (side === 'sell' && selectedPosition && qty > selectedPosition.qty) {
    return `보유 수량 초과 (최대: ${formatQuantity(selectedPosition.qty)})`;
  }

  if (estimatedAmount > 0) {
    if (estimatedAmount < MIN_ORDER_AMOUNT) {
      return `최소 주문 금액 ${formatCurrency(MIN_ORDER_AMOUNT)} 미만`;
    }

    if (side === 'buy' && estimatedAmount > accountCash) {
      return `잔고 부족 (보유: ${formatCurrency(accountCash)}, 필요: ${formatCurrency(estimatedAmount)})`;
    }
  }

  return null;
};

function formatQuantity(value: number): string {
  return value.toLocaleString('ko-KR', { maximumFractionDigits: 6 });
}

export const isOrderValid = (
  symbol: string,
  quantity: string,
  side: 'buy' | 'sell',
  selectedPosition: PositionInfo | null,
  estimatedAmount: number,
  accountCash: number
): boolean => {
  if (!symbol.trim()) return false;
  const qty = parseFloat(quantity);
  if (isNaN(qty) || qty <= 0) return false;
  return getValidationError(symbol, quantity, side, selectedPosition, estimatedAmount, accountCash) === null;
};
